// Service pour interagir avec l'API OpenFoodFacts
const OPENFOODFACTS_API_BASE = 'https://world.openfoodfacts.org/api/v0/product';

/**
 * Récupère les informations d'un produit via son code-barres
 * @param {string} barcode - Le code-barres du produit
 * @returns {Promise<Object>} Les informations du produit
 */
export const getProductByBarcode = async (barcode) => {
  try {
    const response = await fetch(`${OPENFOODFACTS_API_BASE}/${barcode}.json`);
    const data = await response.json();
    
    if (data.status === 1) {
      // Produit trouvé
      const product = data.product;
      return {
        success: true,
        product: {
          name: product.product_name_fr || product.product_name || product.generic_name || '',
          brand: product.brands || '',
          image: product.image_front_url || product.image_url || '',
          description: product.generic_name_fr || product.generic_name || '',
          barcode: barcode,
          quantity: product.quantity || '',
          ingredients: product.ingredients_text_fr || product.ingredients_text || '',
          nutritionGrade: product.nutrition_grade_fr || product.nutrition_grade || '',
          allergens: product.allergens_tags || [],
          categories: product.categories_tags || [],
          // Prix et unité ne sont pas disponibles dans OpenFoodFacts
          price: null,
          unitPrice: null,
          unitType: null
        }
      };
    } else {
      // Produit non trouvé
      return {
        success: false,
        error: 'Produit non trouvé dans la base de données OpenFoodFacts'
      };
    }
  } catch (error) {
    console.error('Erreur lors de la récupération du produit:', error);
    return {
      success: false,
      error: 'Erreur lors de la récupération des informations du produit'
    };
  }
};

/**
 * Génère l'URL de la page OpenFoodFacts pour un produit
 * @param {string} barcode - Le code-barres du produit
 * @returns {string} L'URL de la page OpenFoodFacts
 */
export const getOpenFoodFactsUrl = (barcode) => {
  return `https://world.openfoodfacts.org/product/${barcode}`;
}; 